export default __webpack_public_path__ + "static/media/trackingLoading.c992a7e6.gif";